import styled from "styled-components";
import { ButtonA } from "../../styles-components/Buttons";
import { DaysAgo } from "../../styles-components/Texts";

export const Wrapper = styled.div``;

export const SpecialEvent = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;

  section ${ButtonA} {
    padding-left: 0;
  }
`;

export const Info = styled.div`
  padding: 0 10px;
  width: 100%;
  font-size: 1rem;

  h5 {
    margin-top: 20px;
  }

  p {
    margin: 0;
    padding: 0;
    font-size: 0.7rem.
  }
`;

export const Header = styled.nav`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 10px;

  ${DaysAgo} {
    margin-top: 5px;
  }
`;

export const GroupButtons = styled.nav`
  ${ButtonA} {
    display: block;
    margin-bottom: 5px;
  }
`;


export const ButtonBadge = styled.button`
  padding: 0;
  margin-left:5px;
  background: transparent;
  border: none;
`;

export const HeaderFilter = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;

  div {
    display: block;

    > {
      display: inline-block;
    }
  }
`;
